import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    margin: '32px',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

const LoadingPage = ({ text }) => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <CircularProgress color='primary' />
      <p>{text}</p>
    </div>
  )
}

export default LoadingPage
